export default __webpack_public_path__ + "static/media/03_photo.8f453fe9.jpg";